import React, { useEffect, useState } from "react";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import {
  Layout,
  Card,
  Form,
  Select,
  InputNumber,
  Input,
  Button,
  Spin,
} from "antd";

import { getAPI, postAPI, displayMessage } from "../../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../../constants/messages";
import { ALL_LAUNDRY_ITEM, STOCK_ADJUST } from "../../../constants/api";

const { Content } = Layout;
const { Option } = Select;

function StockAdjustment() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    getAPI(ALL_LAUNDRY_ITEM, (res) => {
      if (res.status) setItems(res.data);
    });
  }, []);

  const submitData = (values) => {
    setLoading(true);

    postAPI(
      STOCK_ADJUST,
      values,
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          form.resetFields();
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to adjust stock");
      }
    );
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card title="Manual Stock Adjustment">
          <Spin spinning={loading}>
            <Form layout="vertical" form={form} onFinish={submitData}>
              <Form.Item
                name="item_id"
                label="Item"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select Item">
                  {items.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="type"
                label="Adjustment Type"
                rules={[{ required: true }]}
              >
                <Select>
                  <Option value="add">Add Stock</Option>
                  <Option value="reduce">Reduce Stock</Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="qty"
                label="Quantity"
                rules={[{ required: true }]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item
                name="remark"
                label="Remark"
                rules={[{ required: true }]}
              >
                <Input.TextArea rows={3} />
              </Form.Item>

              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{ float: "right" }}
              >
                Submit
              </Button>
            </Form>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default StockAdjustment;
